import Marquee from "react-fast-marquee";
import { Quotes, Star } from "@phosphor-icons/react";

export default function TestimonialMarquee({ testimonials = [] }) {
    if (!testimonials.length) return null;
    return (
        <div className="relative" data-testid="testimonial-marquee">
            <div className="absolute left-0 top-0 bottom-0 w-24 bg-gradient-to-r from-[#030712] to-transparent z-10 pointer-events-none" />
            <div className="absolute right-0 top-0 bottom-0 w-24 bg-gradient-to-l from-[#030712] to-transparent z-10 pointer-events-none" />
            <Marquee gradient={false} speed={30} pauseOnHover>
                {testimonials.map((t) => (
                    <article
                        key={t.id}
                        className="tech-card p-6 mx-3 w-[340px] md:w-[400px]"
                        data-testid={`testimonial-${t.id}`}
                    >
                        <Quotes size={24} weight="fill" className="text-orange-400 mb-3" />
                        <p className="text-slate-200 text-sm leading-relaxed min-h-[90px]">"{t.quote}"</p>
                        <div className="flex items-center gap-1 mt-4">
                            {Array.from({ length: t.rating || 5 }).map((_, i) => (
                                <Star key={`${t.id}-star-${i}`} size={14} weight="fill" className="text-cyan-400" />
                            ))}
                        </div>
                        <div className="mt-4 pt-4 border-t border-slate-800">
                            <div className="font-heading font-semibold text-slate-100 text-sm">{t.name}</div>
                            <div className="text-xs text-slate-400">
                                {t.role} · {t.company}
                            </div>
                            <div className="text-xs text-cyan-400 font-mono-alt mt-1">{t.state}</div>
                        </div>
                    </article>
                ))}
            </Marquee>
        </div>
    );
}
